// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContactMailingList } from './contact-mailing-list';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MailingList extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  mailingListId!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  contactMailingLists!: ContactMailingList[];
}

